import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Button,
  List,
  Dropdown,
  Header,
  Image,
  Grid,
  Segment,
  Popup,
  Checkbox,
  Card,
  Form,
} from "semantic-ui-react";
import { useDropzone } from "react-dropzone";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  addDocuments,
  getDocumentsDetails,
  getAllDocumentUsersData,
  getDatasetUsersData,
  AddDocumentUsersData,
  getDocumentSuccess,
  DatasetUsersDataSuccess,
  AddDatasetUsersDataSuccess,
  DeleteDocumentSuccess,
  requestSuccess,
  fetchDocSettings,
  fetchDocSettingsSuccess,
  saveServiceNowIntegration,
  fetchServiceNowIntegration,
  deleteServiceNowIntegration,
  sendEmailSupport,
  deleteEmailSupport,
  getEmailSupport,
  configureHumanAgentEmail,
  getAgentEmail,
  deleteAgentEmail,
  fetchAssistantParameters,
} from "../../actions/dataConsoleAction";
import AddUserDocPaginationTable from "../Pagination/AddUserDocPaginationTable";
import TableRowsLoader from "../Pagination/TableRowsLoader";
import "../../styles/Dataconsole.css";
import DocUploadStatusModal from "./DocUploadStatusModal";
import DatasetDocDetailsPage from "./DatasetDocDetailsPage";
import DatasetDetailsUsers from "./DatasetDetailsUsers";
import Loader from "../../components/Loader";
import "../../styles/MobileDataConsole.css";
import "../../styles/ThirdPartyIntegrations.css";
import CardPaginationTable from "../Pagination/CardPaginationTable";
import RetrievalParameter from "./RetrievalParameter"; // Import the new component
import DocSettings from "./DocSettings";
import QnaSettingsHistory from "./QnaSettingshistory";
import DocSettingsHistory from "./DocSettingshistory";
import AssistantSettings from "./AssistantSettings"; // Import AssistantSettings
import "../../styles/DocSettings.css";
import TextfieldComponent from "../../uiComponents/TextField/TextfieldComponent";
import CustomFileUpload from "../../uiComponents/CustomFiles/customFileUpload"; // Import CustomFileUpload component

import { set } from "react-hook-form";
import { borderTop, color, display, padding } from "@mui/system";

import { jwtDecode } from "jwt-decode";
import { da } from "date-fns/locale";

// Inside your component:
const token = localStorage.getItem("token");
let orgKey = "";
if (token) {
  try {
    const decodedToken = jwtDecode(token);
    orgKey = decodedToken.extension_Organization;
  } catch (error) {
    console.error("Error decoding token:", error);
  }
}


const parseSize = (sizeStr) => {
  const lower = sizeStr.toLowerCase();
  if (lower.endsWith("mb")) {
    return parseFloat(lower) * 1024 * 1024;
  }
  if (lower.endsWith("kb")) {
    return parseFloat(lower) * 1024;
  }
  return parseInt(sizeStr, 10);
};

const maxSize = parseSize(process.env.REACT_APP_MAXSIZE_DOCUMENT || "20971520");

const DataConsole = ({
  setDatsetCount,
  showToaster,
  setnavTitle,
  dataFromChild,
  OpenDatasetDocList,
  OpenDatasetUserList,
  OpenRetrievalParam,
  OpenQnaSettings,
  OpenDocumentsettings,
  OpenDocsettingsList,
  OpenAssistantSettings, // Add this prop for Assistant Settings
  tabTitle,
  setCloseDocUpload,
  DatasetDocUpload,
  DatasetUrlUpload,
  OpenUserUpload,
  handleCloseUserUpload,
  handleCloseUrlUpload,
  openDocList,
  openuserList,
  openRetrievallist,
  OpenQnaSettingsHistorylist,
  OpenDocSettingsHistorylist,
  handleOpenAssistantDoc,
  handleOpenDocList,
  handleOpenAssistantSettings, // Add this handler for Assistant Settings
  userType, // Receive the userType prop
  isAssistantDataset,
  datasetDetails,
}) => {

  const dispatch = useDispatch();

  const { datasetId, datasetNameParam } = useParams();
  const isMounted = useRef(true);
  const { parameters } = useSelector((state) => state.assistantParameters);
  
  const { addDocData, error, addDocDataStatus } = useSelector(
    (state) => state.addDocReducer || {}
  );
  const { docListData, docListDataStatus } = useSelector(
    (state) => state.getDocReducer || {}
  );
  const { documentUserListData } = useSelector(
    (state) => state.documentUserList || {}
  );
  const { datasetUserListData, datasetUserListDataStatus } = useSelector(
    (state) => state.datasetUserList || {}
  );

  const { datasetUserAddData, addUserToDatasetStatus } = useSelector(
    (state) => state.AddDatasetUser || {}
  );
  const { datasetUserDeleteData } = useSelector(
    (state) => state.DeleteDatasetUser || {}
  );


  const { docSettings, UpdateDocSettingsStatus } = useSelector(
    (state) =>
      state.fetchdocSettings || {
        docSettings: {},
        loading: false,
        error: null,
        UpdateDocSettingsStatus: null,
      }
  );

  const [isAssistant, setIsAssistant] = useState("")

  useEffect(() => {
    // Save isAssistantDataset to localStorage when it changes
    if (isAssistantDataset !== undefined) {
      localStorage.setItem("isAssistantDataset", JSON.stringify(isAssistantDataset));
    }
  }, [isAssistantDataset]);
  
  useEffect(() => {
    // Retrieve isAssistantDataset from localStorage on component mount
    const storedIsAssistantDataset = localStorage.getItem("isAssistantDataset");
    if (storedIsAssistantDataset !== null) {
      setIsAssistant(JSON.parse(storedIsAssistantDataset));
    }
  }, []);



  const [OpenThirdPartyIntegrationBox, setOpenThirdPartyIntegrationBox] = useState(false);
  const handleOpenThirdPartyIntegrationBox = async () => {
    try {
      setShowLoader(true); // Show loader before API call

      // Close other tabs and open the Third Party Integrations tab
      setOpenDocListBox(false);
      setOpenUserListBox(false);
      setOpenRetrievalParamBox(false);
      setOpenDocSettings(false);
      setOpenQnaSettingsHistoryBox(false);
      setOpenDocSettingsHistoryBox(false);

      await dispatch(fetchServiceNowIntegration(datasetId)); // Trigger the API call
      dispatch(getAgentEmail(datasetId));
      setOpenThirdPartyIntegrationBox(true); // Open the tab after successful API response
    } catch (error) {
      console.error("Error fetching Third Party Integration data:", error);
    } finally {
      setShowLoader(false); // Hide loader after API call completes
    }
  };



  //const [OpenDocUpload, setOpenDocUpload] = useState(false);
  const [UpdatedFiles, setUpdatedFiles] = useState(false);
  const [open, setOpen] = useState(false);
  const [openUserBox, setopenUserBox] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedAction, setSelectedAction] = useState("text");
  const [isButtonEnabled, setButtonEnabled] = useState(true);
  const [filesData, setfilesData] = useState([]);
  const [maxFilesSize, setmaxFilesSize] = useState("");
  const [maxFilesCount, setmaxFilesCount] = useState("");
  const [userData, setuserData] = useState([]);
  const [datasetUserData, setdatasetUserData] = useState([]);
  const [DocStatusArray, setDocStatusArray] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [filterDocdata, setfilterDocdata] = useState(false);
  const [DeleteuserDataFlag, setDeleteuserDataFlag] = useState(false);
  const [selectedUsersData, setselectedUsersData] = useState([]);
  const [addUserFlag, setaddUserFlag] = useState(false);
  const [isFilesData, setisFilesData] = useState(true);
  const [isUserData, setisUserData] = useState(false);
  const [dataFromChildCheckbox, setDataFromChildCheckbox] = useState([]);
  const [DocUploadStatusFlag, setDocUploadStatusFlag] = useState(false);
  const [noRecordFound, setNoRecordFound] = useState(true);
  const [showDocumentError, setshowDocumentError] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [OpenDocListBox, setOpenDocListBox] = useState(true);
  const [OpenUserListBox, setOpenUserListBox] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9); // Default rows per page
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [loading, setLoading] = useState(true);
  const [OpenRetrievalParamBox, setOpenRetrievalParamBox] = useState(false);
  const [OpenQnaSettingsHistoryBox, setOpenQnaSettingsHistoryBox] =
    useState(false);
  const [OpenDocSettingsHistoryBox, setOpenDocSettingsHistoryBox] =
    useState(false);
  const [OpenAssistantSettingsBox, setOpenAssistantSettingsBox] = useState(false); 
  const [retrievalParams, setRetrievalParams] = useState({});
  const [retrievalParamsFlag, setRetrievalParamsFlag] = useState(false);
  const [checkboxStates, setCheckboxStates] = useState({});
  const [params, setParams] = useState({}); // Replace with your actual params state
  const [OpenDocSettings, setOpenDocSettings] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const documents = useSelector((state) => state.documents); // Assuming documents are stored in the Redux state
  const [docSettingsBox, setDocSettingsBox] = useState(false);
  const [openUrlBox, setOpenUrlBox] = useState(false);
  // State for DocSettings parameters

  const [chunkSize, setChunkSize] = useState(
    parseInt(process.env.REACT_APP_CHUNK_SIZE, 10) || 100
  );

  const {successAgentEmail,AgentEmailId} = useSelector((state) => state.getAgentEmail || {});

  const [agentEmail, setAgentEmail] = useState("");
  const [agentEmailSaveButtonDisabled, setAgentEmailSaveButtonDisabled] = useState(false);


  const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);

  // URL validation regex
  const isValidUrl = (url) => {
    const regex = /^(https?:\/\/)?([a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(([0-9]{1,5})?\/.*)?$)/i;
    return regex.test(url);
  };


  // Retrieves the "serviceNowIntegration" slice (assuming you set it up in your reducer)
  const { data: serviceNowData } = useSelector((state) => state.serviceNowIntegration || {});
  const [instance, setInstance] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [supportEmail, setSupportEmail] = useState(""); // New state for Email Support Settings
  const[supportPrompt, setSupportPrompt] = useState("");
  const [thirdPartySubTab, setThirdPartySubTab] = useState("instance"); 
  useEffect(() => {
    if (!serviceNowData || !serviceNowData.credential) {
      setInstance("");
      setUsername("");
      setPassword("");
      setSaveButtonDisabled(false);
    } else {
      // The GET API returns only instance & username, so we hardcode password to "*****"
      setInstance(serviceNowData.credential.instance || "");
      setUsername(serviceNowData.credential.username || "");
      setPassword("*****");
      setSaveButtonDisabled(true);
    }
  }, [serviceNowData]);
  useEffect(() => {
    if (thirdPartySubTab === "emailSupport") {
      setShowLoader(true);
      dispatch(getEmailSupport(datasetId, orgKey))
        .then((res) => {
          // Check if the API returned a valid email in the nested data object
          if (res.data && res.data.data && res.data.data.toEmail) {
            setSupportEmail(res.data.data.toEmail);
            setSupportPrompt(res.data.data.prompt);
            setSaveButtonDisabled(true);  // Disable input and save if email exists
          } else {
            if (process.env.REACT_APP_EMAIL_SUPPORT_DOMAIN?.includes(".prod")) {
              const emailSupportDomain = process.env.REACT_APP_EMAIL_SUPPORT_DOMAIN.replace(".prod", "");
              setSupportEmail(emailSupportDomain + datasetId + "@innoverdigital.com");
            }
            else {
            setSupportEmail(process.env.REACT_APP_EMAIL_SUPPORT_DOMAIN + datasetId + "@innoverdigital.com")}
            setSupportPrompt("Please ensure your email contains all the necessary details to create a ticket. If any details are missing, I will ask for clarification");
            setSaveButtonDisabled(false); // Enable input and save if email is missing
          }}
        )
        .catch((error) => {
          console.error("Error fetching email support:", error);
          setSupportEmail("");
          setSupportPrompt("");
          setSaveButtonDisabled(false);
        })
        .finally(() => {
          setShowLoader(false);
        });
    }
  }, [thirdPartySubTab, orgKey]);
  

  const [numList, setNumList] = useState(
    parseInt(process.env.REACT_APP_NUM_LIST, 10) || 1
  );
  const [embeddingModel, setEmbeddingModel] = useState(
    process.env.REACT_APP_EMBEDDING_MODEL || "text-embedding-ada-002"
  );
  const [embeddingDeployment, setEmbeddingDeployment] = useState(
    process.env.REACT_APP_EMBEDDING_DEPLOYMENT || "smart-agent-embedding-ada"
  );
  const [trainingModel, setTrainingModel] = useState(
    process.env.REACT_APP_TRAINING_MODEL || "gpt-4o-mini"
  );
  const [trainingMethod, setTrainingMethod] = useState(
    process.env.REACT_APP_TRAINING_METHOD || "Multi-modal"
  );
  const [imageSummarizationPrompt, setImageSummarizationPrompt] = useState(
    process.env.REACT_APP_IMAGE_SUMMARIZATION_PROMPT || ""
  );
  const [chunk, setChunk] = useState(
    parseInt(process.env.REACT_APP_CHUNK  ,10)|| 800
   );
  const [chunkOverlap, setChunkOverlap] = useState(
     parseInt(process.env.REACT_APP_CHUNK_OVERLAP, 10) 
   );
  const [docChunkEnabled, setDocChunkEnabled] =useState(
     parseInt(process.env.REACT_APP_DOU_AS_CHUNK, 10) || 0
   );
   // State for assistant settings
  const [assistantSettings, setAssistantSettings] = useState({
    chunkingStrategy: "auto",
    chunkSize: 800,
    chunkOverlap: 320,
  });
  const [pageAsChunkEnabled, setPageAsChunkEnabled] = useState(true); // Initialize to true
  const [mapSummaryTemplate, setMapSummaryTemplate] = useState(process.env.REACT_APP_PAGE_SUMMARY_PROMPT || "");
  const [reduceSummaryTemplate, setReduceSummaryTemplate] = useState(process.env.REACT_APP_DOCUMENT_SUMMARY_PROMPT || "");
  const [csvColumns, setCSVColumns] = useState(process.env.CSV_COLUMNS_TO_EXTRACT || "");
  const [serviceAgentEnabled, setServiceAgentEnabled] = useState(process.env.REACT_APP_SERVICE_AGENT_ENABLED || false);
  const [docAsChunkEnabled, setDocAsChunkEnabled] = useState(process.env.REACT_APP_DOC_AS_CHUNK_ENABLED || false);
  const [isLoading, setIsLoading] = useState(false);
  const [shouldResetForm, setShouldResetForm] = useState(true);
  const [documentId, setDocumentId] = useState(null); // State to store the _id
  const [CheckDuplicateFiles, setCheckDuplicateFiles] = useState([]);
  const [fileExistFlag, setFileExistFlag] = useState(false);
  const [UrlSendActiveFlag, setUrlSendActiveFlag] = useState(false);
  const [isHovered, setIsHovered] = useState(false);


  const [inputLinkValue, setInputLinkValue] = useState('');
  const [addedLinks, setAddedLinks] = useState([]);
  const [selectedFrequency, setSelectedFrequency] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [urlErrorMessage, setUrlErrorMessage] = useState('');

  const validateUrl = (url) => {
    const regex = /^(https?:\/\/)?([a-z0-9]+[.-])*[a-z0-9]+\.[a-z]{2,}(:[0-9]+)?(\/[a-z0-9%_.~+-]*)*(\?[;&a-z0-9%_.~+=-]*)?(#[-a-z0-9_]*)?$/i;
    return regex.test(url);
  };

  const toggleVisibility = () => {
    setIsVisible(prevState => !prevState);
  };

  useEffect(() => {
    handleCheckLink();
  }, [inputLinkValue]);

  const handleCheckLink = () => {
    setUrlErrorMessage('');
    if (!validateUrl(inputLinkValue) && inputLinkValue) {
      setUrlErrorMessage('Please enter a valid URL');
      return;  // Don't proceed if the URL is invalid
    } else if (addedLinks.includes(inputLinkValue)) {
      setUrlErrorMessage('This URL already exists');
      return;  // Don't proceed if the URL already exists
    } else {
      setUrlErrorMessage('');
    }
  };

  const handleAddLink = () => {

    // Add the link if it's not empty and doesn't already exist
    if (!isValidUrl(inputLinkValue)) {
      return;  // Don't proceed if the URL is invalid
    } else if (inputLinkValue && !addedLinks.includes(inputLinkValue)) {
      setUrlErrorMessage('');
      setAddedLinks([...addedLinks, inputLinkValue]);
      setInputLinkValue('');  // Clear input after adding
    }
  };


  const handleRemoveLink = (linkToRemove) => {
    // Filter out the link to remove
    setAddedLinks(addedLinks.filter(link => link !== linkToRemove));
  };

  const getDataSet = async (datasetId) => {
    try {
      setShowLoader(true); // Show loader before the API call
      await dispatch(fetchDocSettings(datasetId)); // Call the API
    } catch (error) {
      console.error("Error in getting DataSet:", error);
    } finally {
      setShowLoader(false); // Hide loader after the API call completes
    }
  };

  useEffect(() => {
    if (datasetId && isAssistantDataset) {
      // Fetch assistant settings when datasetId or isAssistantDataset changes
      dispatch(fetchAssistantParameters(datasetId));
    }
  }, [datasetId, isAssistantDataset, dispatch]);

  useEffect(() => {
    if (parameters) {
      // Update assistant settings state when parameters are fetched
      setAssistantSettings({
        chunkingStrategy: parameters.chunkingStrategy || "auto",
        chunkSize: parameters.chunkSize || 800,
        chunkOverlap: parameters.chunkOverlap || 320,
      });
    }
  }, [parameters]);
  
  useEffect(() => {
    if(AgentEmailId){
      setAgentEmail(AgentEmailId);
      setAgentEmailSaveButtonDisabled(true);
    }
  },[AgentEmailId]);

  useEffect(() => {
    if (docSettings && docSettings.length > 0) {
      const settings = docSettings[0]; // Access the first element of the array

      // Check if settings is null, undefined, or an empty object
      if (!settings || Object.keys(settings).length === 0) {
        resetFormFields();
      } else if (
        settings.success === false &&
        settings.message.includes("parameter not found")
      ) {
        alert("Parameter not found");
      } else if (settings._id) {
        setChunkSize(settings.chunkSize);
        setChunk(settings.chunk || 800);
        setChunkOverlap(settings.chunkOverlap);
        setDocChunkEnabled(settings.docChunkEnabled|| 0);
        setNumList(settings.numList);
        setEmbeddingModel(settings.embeddingModel || "");
        setEmbeddingDeployment(
          settings.embeddingDeployment || "smart-agent-embedding-ada"
        );
        setTrainingModel(settings.trainingModel || "gpt-4o-mini");
        setTrainingMethod(settings.trainingMethod || "Multi-modal");
        setImageSummarizationPrompt(settings.imageSummarizationPrompt || "");
        setMapSummaryTemplate(settings.mapSummaryTemplate || "");
        setReduceSummaryTemplate(settings.reduceSummaryTemplate || "");
        setCSVColumns(settings.csvColumns || "");
        setServiceAgentEnabled(settings.serviceAgentEnabled || false);
        setDocAsChunkEnabled(settings.docAsChunkEnabled || false);
        setPageAsChunkEnabled(settings.pageAsChunkEnabled || false);
        setIsLoading(false);
      }
    } else {
      resetFormFields();
    }
  }, [docSettings]);

  useEffect(() => {
    if (UpdateDocSettingsStatus === 200) {
      showToaster("Prompt updated successfully", "success");
      getDataSet(datasetId);
    } else {
      console.error("Error updating prompt:", docSettings);
    }
  }, [UpdateDocSettingsStatus]);

  const resetFormFields = () => {
    setChunkSize(process.env.REACT_APP_CHUNK_SIZE || 100);
    setChunk(process.env.REACT_APP_CHUNK || 500);
    setChunkOverlap(process.env.REACT_APP_CHUNK_OVERLAP || 150);
    setDocChunkEnabled(process.env.REACT_APP_DOC_AS_CHUNK || 0);
    setNumList(process.env.REACT_APP_NUM_LIST || 1);
    setEmbeddingModel(
      process.env.REACT_APP_EMBEDDING_MODEL || "text-embedding-ada-002"
    );
    setEmbeddingDeployment(
      process.env.REACT_APP_EMBEDDING_DEPLOYMENT || "smart-agent-embedding-ada"
    );
    setTrainingModel(process.env.REACT_APP_TRAINING_MODEL || "gpt-4o-mini");
    setTrainingMethod(process.env.REACT_APP_TRAINING_METHOD || "Multi-modal");
    setImageSummarizationPrompt(
      process.env.REACT_APP_IMAGE_SUMMARIZATION_PROMPT || ""
    );
    setMapSummaryTemplate("");
    setReduceSummaryTemplate("");
    setCSVColumns("");
    setServiceAgentEnabled(false);
    setDocAsChunkEnabled(false);
    setPageAsChunkEnabled(true); // Ensure it is reset to true
  };

  useEffect(() => {
    if (documents && documents.length > 0) {
      setIsReadOnly(true);
    } else {
      setIsReadOnly(false);
    }
  }, [documents]);

  const saveParams = (id, newParams) => {
    setParams((prevParams) => ({
      ...prevParams,
      [id]: newParams,
    }));
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleSaveRetrievalParams = (params) => {
    setRetrievalParams(params);
    // You can also dispatch an action or perform any other logic with the params
  };

  useEffect(() => {
    setOpenDocListBox(OpenDatasetDocList);
    setOpenUserListBox(OpenDatasetUserList);
    setOpenRetrievalParamBox(OpenRetrievalParam);
    setDocSettingsBox(OpenDocsettingsList);
    setOpenQnaSettingsHistoryBox(OpenQnaSettings);
    setOpenDocSettingsHistoryBox(OpenDocumentsettings);
  }, [
    OpenDatasetDocList,
    OpenDatasetUserList,
    OpenRetrievalParam,
    OpenDocsettingsList,
    OpenQnaSettings,
    OpenDocumentsettings,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const onDrop = (acceptedFiles, fileType) => {
    // const maxSize = parseInt(process.env.REACT_APP_MAXSIZE_DOCUMENT);
    const maxCount = parseInt(process.env.REACT_APP_MAXCOUNT_DOCUMENT);
    const maxCsvSize = parseInt(process.env.REACT_APP_MAX_CSV_SIZE);

    const validFiles = acceptedFiles.filter((file) => file.size <= maxSize);

    const fileExists = validFiles.some(file =>
      CheckDuplicateFiles.some(f => f.name === file.name)
    );

    if (fileExists) {
      setFileExistFlag(true);
    } else {
      setCheckDuplicateFiles(prevFiles => [...prevFiles, ...validFiles]);
    }

    if (acceptedFiles.length === 0) {
      if (fileType === "onlypdf") {
        setmaxFilesSize("Please upload only pdf or markdown files.");
      } else if (fileType === "pdfandcsv") {
        setmaxFilesSize("Please upload only pdf, csv, or markdown files.");
      } else if (fileType === "pdfonly") {
        setmaxFilesSize("Please upload only pdf files.");
      }
      setshowDocumentError(true);
      return;
    } else if (validFiles.length === 0) {
      setmaxFilesSize(process.env.REACT_APP_DOCUMENT_LARGE_FILE_ERROR);
      setshowDocumentError(true);
      return;
    }

    // Process each file, checking CSV row count if applicable
    validFiles.forEach((file) => {
      if (file.name.endsWith(".csv")) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const rows = event.target.result.split("\n");

          // Check if CSV row count exceeds limit
          if (rows.length > maxCsvSize) {
            setmaxFilesSize(
              `CSV file has more than ${maxCsvSize - 2} entries. Please upload a smaller file.`
            );
            setshowDocumentError(true);
            return;
          } else {
            // Add the file to uploadedFiles only if it passes the row count check
            setUploadedFiles((prevFiles) => {
              const newFiles = validFiles
                .filter(
                  (newFile) =>
                    !prevFiles.some(
                      (prevFile) =>
                        prevFile.name === newFile.name &&
                        prevFile.size === newFile.size
                    )
                )
                .map((file) => ({
                  id: Math.random().toString(36).substr(2, 9),
                  name: file.name,
                  size: file.size,
                  files: file,
                  fileflag: fileType,
                }));

              const updatedFiles = [...prevFiles, ...newFiles];

              if (updatedFiles.length > maxCount) {
                setButtonEnabled(false);
                setmaxFilesCount(
                  process.env.REACT_APP_DOCUMENT_MAX_NUMBER_FILE_ERROR
                );
                setshowDocumentError(true);
                return prevFiles;
              } else {
                setButtonEnabled(true);
              }

              return updatedFiles;
            });
          }
        };
        reader.readAsText(file);
      } else {
        // Non-CSV files (including MD files), proceed as usual
        setUploadedFiles((prevFiles) => {
          const newFiles = validFiles
            .filter(
              (newFile) =>
                !prevFiles.some(
                  (prevFile) =>
                    prevFile.name === newFile.name &&
                    prevFile.size === newFile.size
                )
            )
            .map((file) => ({
              id: Math.random().toString(36).substr(2, 9),
              name: file.name,
              size: file.size,
              files: file,
              fileflag: fileType,
            }));

          const updatedFiles = [...prevFiles, ...newFiles];

          if (updatedFiles.length > maxCount) {
            setButtonEnabled(false);
            setmaxFilesCount(
              process.env.REACT_APP_DOCUMENT_MAX_NUMBER_FILE_ERROR
            );
            setshowDocumentError(true);
            return prevFiles;
          } else {
            setButtonEnabled(true);
          }

          return updatedFiles;
        });
      }
    });
  };


  const handleCheckboxChange = (fileId, checkboxType) => {
    setCheckboxStates((prevState) => ({
      ...prevState,
      [fileId]: {
        ...prevState[fileId],
        [checkboxType]: !prevState[fileId]?.[checkboxType], // Toggle the checkbox state
      },
    }));
  };

  const {
    getRootProps: getRootPropsPDF,
    getInputProps: getInputPropsPDF,
    isDragActive: isDragActivePDF,
  } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
      "text/markdown": [".md"],
    },
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, "onlypdf"),
  });

  const {
    getRootProps: getRootPropsPDFOnly,
    getInputProps: getInputPropsPDFOnly,
    isDragActive: isDragActivePDFOnly,
  } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
    },
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, "pdfonly"),
  });

  const {
    getRootProps: getRootPropsPDFCSV,
    getInputProps: getInputPropsPDFCSV,
    isDragActive: isDragActivePDFCSV,
  } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
      "text/csv": [".csv", ".Csv"],
      "text/markdown": [".md"],
    },
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, "pdfandcsv"),
  });

  const closeDocumentErrorBox = () => {
    setshowDocumentError(false);
  };

  const closeDocumentFlagErrorBox = () => {
    setFileExistFlag(false);
  };

  const columnsHead = [
    { id: "documentName", label: "Document" },
    { id: "documentType", label: "Extraction Type" },
  ];
  const columnsSkelton = [
    { id: "filename", label: "Document" },
    { id: "extractiontype", label: "Extraction Type" },
    { id: "action", label: "Action" },
  ];

  const userColumns = [
    { id: "displayName", label: "Name" },
    { id: "email", label: "" },
  ];

  const datasetUserColumns = [
    { id: "displayName", label: "Name" },
    { id: "email", label: "Email" },
  ];
  const datasetUserColumnsSkelton = [
    { id: "username", label: "Name" },
    { id: "action", label: "Action" },
  ];

  useEffect(() => {
    if (isMounted.current) {
      fetchData();
      fetchAllUsersData();
      fetchDatasetUsersData();
      getDataSet(datasetId);
      isMounted.current = false;
      dispatch(DatasetUsersDataSuccess([]));
      dispatch(getDocumentSuccess([]));
      dispatch(fetchDocSettingsSuccess([]));
    }
  }, [datasetId]);

  useEffect(() => {
    //set unassigned users
    if (documentUserListData && documentUserListData.length > 0) {
      let allUsers = documentUserListData;
      let assignedUsers =
        datasetUserListDataStatus === 200
          ? datasetUserListData.accessUsers
          : [];
      let unassignedUsersList = allUsers.filter(
        (allUsers) =>
          !assignedUsers.some(
            (assignedUsers) => assignedUsers.id === allUsers.id
          )
      );
      let filterData = unassignedUsersList.filter((search) => {
        return search.displayName
          .toString()
          .toLowerCase()
          .includes(inputValue.toString().toLowerCase());
      });
      setuserData(filterData);
    }
    setnavTitle(datasetNameParam);
    setDatsetCount(filesData.length);
  }, [
    documentUserListData,
    datasetNameParam,
    filesData,
    inputValue,
    datasetUserListData,
    datasetUserListDataStatus,
  ]);

  useEffect(() => {
    //set assigned users
    if (datasetUserListDataStatus === 200) {
      setisUserData(true);
      if (dataFromChild) {
        let filterData = datasetUserListData.accessUsers.filter((find) => {
          return find.displayName
            .toString()
            .toLowerCase()
            .includes(dataFromChild);
        });
        if (filterData.length > 0) {
          filterData = filterData.filter(
            (assignedUser) => assignedUser.accessType === "Approved"
          );
          setdatasetUserData(filterData);
        } else {
          setisUserData(false);
          setdatasetUserData([]);
        }
      } else {
        var filterDataVal = datasetUserListData.accessUsers.filter(
          (assignedUser) => assignedUser.accessType === "Approved"
        );
        setdatasetUserData(filterDataVal);
      }
    } else {
      setisUserData(false);
    }
  }, [datasetUserListData, datasetUserListDataStatus, dataFromChild]);

  // Add Document response
  useEffect(() => {
    if (addDocData && addDocDataStatus === 200) {
      if (addDocData.documents.length > 0 && addDocData.documents[0].documentType === "URL") {
        setOpenUrlBox(false);
        setAddedLinks([]);
        setInputLinkValue('');
        showToaster("URL added successfully", "success");
        dispatch(requestSuccess([]));
        if (UrlSendActiveFlag) {
          fetchData();
        }
        setUrlSendActiveFlag(false);
        setShowLoader(false);
      }
    }

    if (filterDocdata && addDocDataStatus === 200) {
      filterDocumentStatus(DocStatusArray);
      fetchData();
      setfilterDocdata(false);
      dispatch(requestSuccess([]));
    } else if (filterDocdata && addDocDataStatus === 400) {
      filterDocumentStatus(DocStatusArray);
      showToaster("Please Configure OpenAI API key", "error");
      setDocUploadStatusFlag(false);
      setDocStatusArray([]);
      setfilterDocdata(false);
      dispatch(requestSuccess([]));
    } else if (filterDocdata && addDocDataStatus === 500) {
      filterDocumentStatus(DocStatusArray);
      showToaster("Error in uploading Document Please try again", "error");
      setDocUploadStatusFlag(false);
      setDocStatusArray([]);
      setfilterDocdata(false);
      dispatch(requestSuccess([]));
    }
  }, [addDocData, filterDocdata, DocStatusArray]);


  //update document list
  useEffect(() => {
    if (docListDataStatus === 200) {
      if (docListData.length > 0) {
        setRefreshFlag(false);
        if (dataFromChild) {
          let filter = docListData.filter((search) => {
            return search.documentName
              .toString()
              .toLowerCase()
              .includes(dataFromChild);
          });
          if (filter.length > 0) {
            setfilesData(filter);
          } else {
            setisFilesData(false);
            setfilesData([]);
          }
        } else {
          setfilesData(docListData);
        }
      }
      if (docListData.length === 0) {
        setfilesData([]);
      }
    } else {
      setfilesData([]);
    }
  }, [docListData, docListDataStatus, dataFromChild]);

  //open model
  useEffect(() => {
    if (DatasetDocUpload) {
      setOpen(true);
    }
  }, [DatasetDocUpload]);

  useEffect(() => {
    if (DatasetUrlUpload) {
      setOpenUrlBox(true);
    }
  }, [DatasetUrlUpload]);

  //delete document
  useEffect(() => {
    if (UpdatedFiles) {
      fetchData();
      setUpdatedFiles(false);
    }
  }, [UpdatedFiles]);

  //Add user response
  useEffect(() => {
    if (addUserFlag && datasetUserAddData && addUserToDatasetStatus) {
      if (addUserToDatasetStatus.status === 200) {
        if (datasetUserAddData.data.length > 1) {
          showToaster("User(s) added successfully", "success");
        } else {
          showToaster("User added successfully", "success");
        }
        setaddUserFlag(false);
        fetchDatasetUsersData();
        fetchAllUsersData();
        dispatch(AddDatasetUsersDataSuccess());
      }
    }
  }, [addUserFlag, datasetUserAddData, addUserToDatasetStatus]);

  //delete User
  useEffect(() => {
    if (DeleteuserDataFlag && datasetUserDeleteData) {
      if (datasetUserDeleteData.status === 200) {
        fetchAllUsersData();
        fetchDatasetUsersData();
        setDeleteuserDataFlag(false);
        dispatch(DeleteDocumentSuccess());
        showToaster("User Deleted successfully!", "success");
      } else {
        showToaster("Please try again!", "error");
      }
    }
  }, [DeleteuserDataFlag, datasetUserDeleteData]);

  //uploaded Files
  useEffect(() => {
    if (uploadedFiles.length > 0) {
      setButtonEnabled(true);
    } else {
      setButtonEnabled(false);
    }
  }, [uploadedFiles]);

  useEffect(() => {
    if (OpenUserUpload) {
      handleOpenUserUpload();
    }
  }, [OpenUserUpload]);

  const handleRefreshDoc = () => {
    fetchData();
    setRefreshFlag(true);
  };

  const filterDocumentStatus = (DocArray) => {
    try {
      DocArray.forEach((item) => {
        const { documentName } = item;
        if (
          addDocData.duplicateFiles.includes(documentName) &&
          item.responseUpdated === 0
        ) {
          item.status = 2;
          item.error = `${process.env.REACT_APP_DOCUMENT_SAME_FILE_ERROR}`;
          item.responseUpdated = 1;
        } else if (
          addDocData.failedFiles.includes(documentName) &&
          item.responseUpdated === 0
        ) {
          item.status = 2;
          item.error = `${process.env.REACT_APP_DOCUMENT_VALID_FILE_ERROR}`;
          item.responseUpdated = 1;
        } else if (
          addDocData.largeFiles.includes(documentName) &&
          item.responseUpdated === 0
        ) {
          item.status = 2;
          item.error = `${process.env.REACT_APP_DOCUMENT_LARGE_FILE_ERROR}`;
          item.responseUpdated = 1;
        } else if (
          addDocData.rejectedFiles.includes(documentName) &&
          item.responseUpdated === 0
        ) {
          item.status = 2;
          item.error = `${process.env.REACT_APP_DOCUMENT_EXTRACTION_FILE_ERROR}`;
          item.responseUpdated = 1;
        } else if (
          addDocData.successFiles.includes(documentName) &&
          item.responseUpdated === 0
        ) {
          item.status = 1;
          item.error = "";
          item.responseUpdated = 1;
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchData = async () => {
    try {
      setUpdatedFiles(false);
      setfilterDocdata(false);
      dispatch(getDocumentsDetails(datasetId));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //get all users
  const fetchAllUsersData = async () => {
    try {
      dispatch(getAllDocumentUsersData());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //Get Specific dataset  users
  const fetchDatasetUsersData = async () => {
    try {
      dispatch(getDatasetUsersData(datasetId));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleOpenDocUpload = () => {
    setOpen(true);
    setCloseDocUpload(false);
  };

  const handleOpenURLUpload = () => {
    setOpenUrlBox(true);
    handleCloseUrlUpload(false);
  };

  const handleOpenUserUpload = () => {
    setopenUserBox(true);
  };

  const handleAddUser = () => {
    setopenUserBox(false);
    try {
      // Initialize an empty array to store user objects
      const usersArray = [];

      // Iterate over the response data array
      dataFromChildCheckbox.forEach((user) => {
        // Construct user object
        const userObject = {
          user: {
            id: user.id,
            displayName: user.displayName,
            email: user.email,
            role: "User",
            userName: user.displayName,
          },
          accessType: "Approved",
        };

        // Push the user object into the usersArray
        usersArray.push(userObject);
      });

      const payload = {
        users: usersArray,
      };

      dispatch(AddDocumentUsersData(payload, datasetId));
      setaddUserFlag(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setUploadedFiles([]);
    //setOpenDocUpload(false);
    setopenUserBox(false);
    setCloseDocUpload(false);
    setshowDocumentError(false);
  };

  const handleCloseUrl = () => {
    setAddedLinks([]);
    setInputLinkValue('');
    setOpenUrlBox(false);
    handleCloseUrlUpload(false);
  };

  const handleCloseUserModel = () => {
    setUploadedFiles([]);
    setopenUserBox(false);
    handleCloseUserUpload(false);
  };

  const handleRemoveFile = (id) => {
    setUploadedFiles((prevFiles) => prevFiles.filter((file) => file.id !== id));
  };

  const handleActionChange = (_, { value }) => {
    setSelectedAction(value);
  };

  const handleCloseDocStatusModal = () => {
    setDocUploadStatusFlag(false);
    setDocStatusArray([]);
  };

  const updateDocStatusArray = (newArray) => {
    setDocStatusArray((prevArray) => [...prevArray, ...newArray]);
  };


  const handleAddDataLinks = () => {

    const docSettings = {
      chunkSize,
      chunk,
      chunkOverlap,
      docChunkEnabled,
      numList,
      embeddingModel,
      embeddingDeployment,
      trainingModel,
      trainingMethod,
      imageSummarizationPrompt,
      mapSummaryTemplate,
      reduceSummaryTemplate,
      csvColumns,
      serviceAgentEnabled,
      docAsChunkEnabled,
      pageAsChunkEnabled,
    };

    try {
      const formData = new FormData();
      formData.append("documentType", "URL");
      formData.append("links", JSON.stringify(addedLinks));
      formData.append("frequency", selectedFrequency);
      if(isAssistant) {
        formData.append("assistantSettings", JSON.stringify(assistantSettings));
      } else {
      formData.append("docSettings", JSON.stringify(docSettings));
      }
      dispatch(addDocuments(formData, datasetId, docSettings));
      setAddedLinks([]);
      setInputLinkValue('');
      setOpenUrlBox(false);
      handleCloseUrlUpload(false);
      setUrlSendActiveFlag(true);
      setShowLoader(true);
    } catch (error) {
      console.error("Error uploading files:", error);
    }

  };



  // upload documents
  const handleUpload = async () => {
    setOpen(false);
    setCloseDocUpload(false);
    //setOpenDocUpload(false);
    setUploadedFiles([]);
    // Use the parameters during document upload
    const docSettings = {
      chunkSize,
      chunk,
      chunkOverlap,
      docChunkEnabled,
      numList,
      embeddingModel,
      embeddingDeployment,
      trainingModel,
      trainingMethod,
      imageSummarizationPrompt,
      mapSummaryTemplate,
      reduceSummaryTemplate,
      csvColumns,
      serviceAgentEnabled,
      docAsChunkEnabled,
      pageAsChunkEnabled,
    };

    try {
      const formData = new FormData();
      formData.append("documentType", "PDF");
      uploadedFiles.forEach((data) => {
        formData.append("files", data.files);
      });
      setfilterDocdata(true);
      setDocUploadStatusFlag(true);
      const docArray = uploadedFiles.flatMap((item) => ({
        documentName: item.files.name,
        status: 0,
        responseUpdated: 0,
        error: "",
      }));
      updateDocStatusArray(docArray);

      // Prepare payload with options based on checkbox selections
      const options = uploadedFiles.reduce((acc, file) => {
        acc[file.name] = {
          isDomainDoc: file.fileflag === "onlypdf",
          isDataDoc: file.fileflag === "pdfandcsv",
        };
        return acc;
      }, {});

      formData.append("options", JSON.stringify(options));
      if (isAssistant) {
        formData.append("assistantSettings", JSON.stringify(assistantSettings));
      } else {
        formData.append("docSettings", JSON.stringify(docSettings));
      }
      dispatch(addDocuments(formData, datasetId));
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const actions = [
    { key: "text", text: "PDF Containing Text Only", value: "text" },
    // { key: "file", text: "PDF Containing Text+Image", value: "image" },
  ];

  const handleDataFromChild = (data) => {
    setDataFromChildCheckbox(data);
  };

  const handleOpenDocListBox = () => {
    setOpenUserListBox(false);
    setOpenDocListBox(true);
    openDocList();
  };

  const handleOpenUserListBox = () => {
    setOpenDocListBox(false);
    setOpenUserListBox(true);
    openuserList();
  };
  const handleOpenRetrievalParamBox = () => {
    setOpenDocListBox(false);
    setOpenUserListBox(false);
    setOpenRetrievalParamBox(true);
    openRetrievallist();
  };
  const handleOpenQnaSettingsHistoryBox = () => {
    setOpenDocListBox(false);
    setOpenUserListBox(false);
    setOpenRetrievalParamBox(false);
    setOpenDocSettings(false);
    setOpenQnaSettingsHistoryBox(true);
    setOpenDocSettingsHistoryBox(false);
    OpenQnaSettingsHistorylist();
  };
  const handleOpenDocSettingsHistoryBox = () => {
    setOpenDocListBox(false);
    setOpenUserListBox(false);
    setOpenRetrievalParamBox(false);
    setOpenDocSettings(false);
    setOpenQnaSettingsHistoryBox(false);
    setOpenDocSettingsHistoryBox(true);
    OpenDocSettingsHistorylist();
  };

  const handleOpenAssistantSettingsBox = () => {
    setOpenAssistantSettingsBox(true);
    setOpenDocListBox(false);
    setOpenUserListBox(false);
    setOpenRetrievalParamBox(false);
    setOpenDocSettings(false);
    setOpenQnaSettingsHistoryBox(false);
    setOpenDocSettingsHistoryBox(false);
    setOpenThirdPartyIntegrationBox(false);
    handleOpenAssistantDoc();
  };

  const HandleOpenDocSettings = () => {
    setOpenDocListBox(false);
    setOpenUserListBox(false);
    setOpenRetrievalParamBox(false);
    setOpenDocSettings(true);
    handleOpenDocList();
    setIsReadOnly(filesData.length > 0);
  };

  const getTimeAgo = (createdUTC) => {
    const today = moment().startOf("day");
    const createdDate = moment.utc(createdUTC).local().startOf("day");

    const timeDifference = today.diff(createdDate, "days");

    if (timeDifference === 0) {
      return "Updated today";
    } else if (timeDifference === 1) {
      return "Updated yesterday";
    } else {
      return `Updated ${timeDifference} days ago`;
    }
  };
  const [isReadOnlyState, setIsReadOnlyState] = useState(false);

  useEffect(() => {
    if (userType === 'DatasetAdmin') {
      setIsReadOnlyState(true);
  }
}, [userType]);

  const handleAgentEmailSave = async () => {
    const payload ={
      datasetId: datasetId,
      agentEmailId: agentEmail
    }
    setShowLoader(true);
    dispatch(configureHumanAgentEmail(payload))
    .then(() => {
      showToaster("Agent email updated successfully", "success");
      setAgentEmailSaveButtonDisabled(true);
    })
    .catch((error) => {
      console.error("Error saving integration:", error);
      showToaster("Failed to save. Please try again.", "error");
    })
    .finally(() => {
      setShowLoader(false);
    });
  }

  const handleAgentEmailDelete = async () => {
    setShowLoader(true);
    dispatch(deleteAgentEmail(datasetId))
    .then(() => {
      showToaster("Agent email deleted successfully", "success");
      setAgentEmail("");
      setAgentEmailSaveButtonDisabled(false);
    })
    .catch((error) => {
      console.error("Error deleting integration:", error);
      showToaster("Failed to delete. Please try again.", "error");
    })
    .finally(() => {
      setShowLoader(false);
    });
  }

  const handleServiceAgentToggle = (value) => {
    if (isAssistant) {
      // Use the value from AssistantSettings.js
      setServiceAgentEnabled(value);
    } else {
      // Use the value defined in Dataconsole.js
      setServiceAgentEnabled(process.env.REACT_APP_SERVICE_AGENT_ENABLED || false);
    }
  };

  return (
    <div>
      {showLoader && <Loader />}


      <div>
        <div className="data-console-sub-header">
          <p className="document-para">
            {datasetUserListData && datasetUserListData.description}
          </p>

          <p className="time-color">
            {datasetUserListData && (
              <Popup
                inverted
                position="right center"
                trigger={
                  <span>{getTimeAgo(datasetUserListData.createdUTC)}</span>
                }
                content={new Date(
                  datasetUserListData.createdUTC
                ).toLocaleDateString()}
                style={{ borderRadius: "15px" }}
              />
            )}{" "}
            &nbsp; &#x2022; &nbsp;
            {datasetUserListData?.createdBy?.displayName}
          </p>
        </div>
        <div className="mobile-dataconsole-container">
          <div className="mobile-dataconsole-header ">
            <div
              className={OpenDocListBox ? "mobile-dataconsole-header-left" : ""}
              onClick={handleOpenDocListBox}
              data-cy="details-documents-title-cy"
            >
              <span>Document</span>{" "}
              <span>
                {" "}
                {filesData.length > 0 ? `(${filesData.length})` : `(0)`}
              </span>
            </div>
            <div
              className={
                !OpenDocListBox && OpenUserListBox
                  ? "mobile-dataconsole-header-left"
                  : ""
              }
              onClick={handleOpenUserListBox}
              data-cy="details-users-title-cy"
            >
              <span>Users</span>{" "}
              <span>
                {datasetUserData.length > 0
                  ? `(${datasetUserData.length})`
                  : `(0)`}
              </span>
            </div>
            {!isAssistant && (
              <div
                className={
                  !OpenDocListBox && !OpenUserListBox && OpenRetrievalParamBox
                    ? "mobile-dataconsole-header-left"
                    : ""
                }
                onClick={handleOpenRetrievalParamBox}
                data-cy="details-retrieval-param-title-cy"
              >
                <span>QnA Settings</span>
              </div>
            )}
            {/* <div
              className={
                !OpenDocListBox && !OpenUserListBox && OpenRetrievalParamBox && OpenDocSettings
                  ? "mobile-dataconsole-header-left"
                  : ""
              }
              onClick={HandleOpenDocSettings}
              data-cy=""
            >
              <span>Document Settings</span>
            </div> */}
            {!isAssistant && (
            <div
              className={
                !OpenDocListBox &&
                  !OpenUserListBox &&
                  !OpenRetrievalParamBox &&
                  OpenDocSettings
                  ? "mobile-dataconsole-header-left"
                  : ""
              }
              onClick={HandleOpenDocSettings}
              data-cy=""
            >
              <span>Document Settings</span>
            </div>
             )}
             {!isAssistant && (
            <div
              className={
                !OpenDocListBox &&
                  !OpenUserListBox &&
                  !OpenRetrievalParamBox &&
                  !OpenDocSettings &&
                  OpenQnaSettingsHistoryBox
                  ? "mobile-dataconsole-header-left"
                  : ""
              }
              onClick={handleOpenQnaSettingsHistoryBox}
              data-cy=""
            >
              <span>Qna Settings History</span>
            </div>
             )}
             {!isAssistant && (
            <div
              className={
                !OpenDocListBox &&
                  !OpenUserListBox &&
                  !OpenRetrievalParamBox &&
                  !OpenDocSettings &&
                  !OpenQnaSettingsHistoryBox &&
                  OpenDocSettingsHistoryBox
                  ? "mobile-dataconsole-header-left"
                  : ""
              }
              onClick={handleOpenDocSettingsHistoryBox}
              data-cy=""
            >
              <span>Document Settings History</span>
            </div>
             )}
            {isAssistant && (
            <div
              className={
                !OpenDocListBox &&
                  !OpenUserListBox &&
                  !OpenRetrievalParamBox &&
                  !OpenDocSettings &&
                  !OpenQnaSettingsHistoryBox &&
                  !OpenDocSettingsHistoryBox &&
                  !OpenThirdPartyIntegrationBox &&
                  OpenAssistantSettingsBox
                  ? "mobile-dataconsole-header-left"
                  : ""
              }
              onClick={handleOpenAssistantSettingsBox}
              data-cy="details-assistant-settings-title-cy"
            >
              <span>Assistant Settings</span>
            </div>
          )}
          {serviceAgentEnabled &&  (
              <div
                className={
                  !OpenDocListBox &&
                    !OpenUserListBox &&
                    !OpenRetrievalParamBox &&
                    !OpenDocSettings &&
                    !OpenQnaSettingsHistoryBox &&
                    !OpenDocSettingsHistoryBox &&
                    OpenThirdPartyIntegrationBox
                    ? "mobile-dataconsole-header-left"
                    : ""
                }
                onClick={handleOpenThirdPartyIntegrationBox}
              >
                <span>Third Party Integrations</span>
              </div>
            )}
          </div>
          {OpenDocListBox && (
            <div className="dataconsole-doc-actions">
              <div
                className={`refresh-button  ${refreshFlag ? "refresh-button-disabled" : ""
                  }`}
                onClick={!refreshFlag ? handleRefreshDoc : null}
                data-cy="refresh-trained-doc-cy"
              >
                <Image src="/images/refresh-color.svg" alt="Refresh" />
                {/* <span>Refresh</span> */}
                <Popup
                  content={
                    "Refresh to retrain all the documents"
                  }
                  inverted
                  position="top center"
                  style={{ borderRadius: "15px", marginBottom: "15px", marginRight: "25px" }}
                  trigger={<label>Refresh</label>}
                />
              </div>
              <div className="dataconsole-add-doc-btn">
                {isVisible && (
                  <div
                    className="floating-box dataconsole-add-floating"
                    style={{
                      border: "1px solid #ccc",
                      backgroundColor: "white",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                      display: "flex",
                      flexDirection: "column",
                      position: "absolute",
                      top: "100%",
                      right: "0",
                      zIndex: 10,
                      marginTop: "4px",
                    }}
                  >
                    <ul style={{ listStyleType: "none", padding: "0", margin: "0" }}>
                      <li
                        onClick={() => {
                          handleOpenDocUpload();
                          toggleVisibility();
                        }}
                        data-cy="add-document-link-top"
                        style={{
                          padding: "10px 16px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                      >
                        Files
                      </li>
                      <li
                        onClick={() => {
                          handleOpenURLUpload();
                          toggleVisibility();
                        }}
                        data-cy="add-url-link-top"
                        style={{
                          padding: "10px 16px",
                          cursor: "pointer",
                        }}
                      >
                        Links
                      </li>
                    </ul>
                  </div>
                )}
                <Button
                  primary
                  onClick={toggleVisibility}
                  className="button-data-console"
                  data-cy="add-document-link-button-top"
                >
                  <div className="button-data-console-parent">
                    <Image
                      src="/images/white-base-icons.svg"
                      alt="Add new Document"
                    />
                    <span>Add</span>
                  </div>
                </Button>
              </div>
            </div>
          )}
        </div>

        <div className="">
          {OpenDocListBox ? (
            <div className="mobile-dataset-content">
              {loading ? (
                <div>
                  <Loader />
                </div>
              ) : filesData.length > 0 ? (
                <>
                  <DatasetDocDetailsPage
                    columns={columnsHead}
                    datas={filesData}
                    docSettings={docSettings}
                    setUpdatedFiles={setUpdatedFiles}
                    showToaster={showToaster}
                  />
                </>
              ) : (
                <div>
                <div className="refresh-and-configure ">
                        <a
                          href="#"
                          onClick={
                          isAssistant
                            ? handleOpenAssistantSettingsBox
                            : HandleOpenDocSettings
                          }
                        >
                          <span className="tab-link">
                          Click here to Configure{" "}
                          {isAssistant ? "Assistant Settings" : "Document Settings"}
                          </span>
                        </a>
                        </div>
              
                  <div className="emptyContainer">
                    <Image src="/images/empty-state.svg" alt="Empty State" />
                    <p className="emptyMessage">
                      <span className="titleMessage">No data available </span>
                      <span>Add your first document</span>
                    </p>
                  </div>
                </div>
              )}
            </div>
          ) : OpenUserListBox ? (
            <div className="mobile-dataset-users">
              {datasetUserData.length > 0 ? (
                <>
                  <DatasetDetailsUsers
                    columns={datasetUserColumns}
                    data={datasetUserData.slice(
                      currentPage * rowsPerPage,
                      (currentPage + 1) * rowsPerPage
                    )}
                    loaderFlag={addUserFlag}
                    setDeleteuserDataFlag={setDeleteuserDataFlag}
                  />
                  <CardPaginationTable
                    totalItems={datasetUserData.length}
                    page={currentPage}
                    rowsPerPage={rowsPerPage}
                    handleChangePage={handleChangePage}
                  />
                </>
              ) : (
                <div className="emptyContainer">
                  {addUserFlag && <Loader />}
                  <Image src="/images/empty-state.svg" alt="Empty State" />
                  <p className="emptyMessage">
                    <span className="titleMessage">No data available</span>
                    <span>Add the first user</span>
                  </p>
                </div>
              )}

              <div className="mobile-dataconsole-add-user">
                <Button
                  onClick={handleOpenUserUpload}
                  className="button-data-console"
                  data-cy="add-users-link"
                >
                  <div className="button-data-console-parent">
                    <Image
                      src="/images/white-base-icons.svg"
                      alt="Add new User"
                    />
                    Add New User
                  </div>
                </Button>
              </div>
            </div>
          ) : OpenRetrievalParamBox ? (
            <div className="retrieval-parameter-form">
              <RetrievalParameter
                datasetId={datasetId}
                saveParams={saveParams}
                params={params}
                userType={userType} // Pass the extensionRole prop
              />
            </div>
          ) : OpenDocSettings ? (
            <div className="doc-settings-form">
              <DocSettings
                datasetId={datasetId}
                isReadOnly={isReadOnly}
                chunkSize={chunkSize}
                setChunkSize={setChunkSize}
                chunk={chunk}
                setChunk={setChunk}
                chunkOverlap={chunkOverlap}
                setChunkOverlap={setChunkOverlap}
                docChunkEnabled={docChunkEnabled}
                setDocChunkEnabled={setDocChunkEnabled}
                numList={numList}
                setNumList={setNumList}
                embeddingModel={embeddingModel}
                setEmbeddingModel={setEmbeddingModel}
                embeddingDeployment={embeddingDeployment}
                setEmbeddingDeployment={setEmbeddingDeployment}
                trainingModel={trainingModel}
                setTrainingModel={setTrainingModel}
                trainingMethod={trainingMethod}
                setTrainingMethod={setTrainingMethod}
                imageSummarizationPrompt={imageSummarizationPrompt}
                setImageSummarizationPrompt={setImageSummarizationPrompt}
                mapSummaryTemplate={mapSummaryTemplate}
                setMapSummaryTemplate={setMapSummaryTemplate}
                reduceSummaryTemplate={reduceSummaryTemplate}
                setReduceSummaryTemplate={setReduceSummaryTemplate}
                setCSVColumns={setCSVColumns}
                serviceAgentEnabled={serviceAgentEnabled}
                setServiceAgentEnabled={setServiceAgentEnabled}
                docAsChunkEnabled={docAsChunkEnabled}
                setDocAsChunkEnabled={setDocAsChunkEnabled}
                pageAsChunkEnabled={pageAsChunkEnabled}
                setPageAsChunkEnabled={setPageAsChunkEnabled}
                userType={userType} // Pass the extensionRole prop
              />
            </div>
          ) : OpenQnaSettingsHistoryBox ? (
            <QnaSettingsHistory datasetId={datasetId} />
          ) : OpenDocSettingsHistoryBox ? (
            <DocSettingsHistory datasetId={datasetId} />

          ) : OpenThirdPartyIntegrationBox ? (
            <div
                className="third-party-integration-container"
                style={{
                height:
                  thirdPartySubTab === "instance"
                  ? "28.5em"
                  : thirdPartySubTab === "emailSupport"
                  ? "29em"
                  : thirdPartySubTab === "agentEmail"
                  ? "17em"
                  : "auto",
                }}
              >              
              {/* <Header as="h3" className="third-party-header">
              Third Party Integrations
            </Header>
            <p className="third-party-desc">
              Enter your third-party instance credentials below:
            </p> */}

              <div
      className="third-party-sub-tab-header"
      style={{ display: "flex", borderBottom: "1px solid #ccc", marginBottom: "1rem" }}
    >
      {/* Clicking this sets the active sub-tab to "instance" */}
      <div
        onClick={() => setThirdPartySubTab("instance")}
        style={{
          padding: "0.5rem 1rem",
          cursor: "pointer",
          borderBottom: thirdPartySubTab === "instance" ? "2px solid blue" : "none"
        }}
      >
        Instance Settings
      </div>
      {/* Clicking this sets the active sub-tab to "emailSupport" */}
      <div
        onClick={() => setThirdPartySubTab("emailSupport")}
        style={{
          padding: "0.5rem 1rem",
          cursor: "pointer",
          borderBottom: thirdPartySubTab === "emailSupport" ? "2px solid blue" : "none"
        }}
      >
        Email Support Settings
      </div>
      <div
      onClick={() => setThirdPartySubTab("agentEmail")}
      style={{
        padding: "0.5rem 1rem",
        cursor: "pointer",
        borderBottom: thirdPartySubTab === "agentEmail" ? "2px solid blue" : "none"
      }}
     >
      Agent Email
    </div>
    </div>

    {/* Conditionally render the Instance Settings form */}
    {thirdPartySubTab === "instance" && (
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Form>
              <Form.Field inline>
                <label style={{ minWidth: "6rem" }}>Instance:</label>
                <input
                  disabled={saveButtonDisabled}
                  value={instance}
                  onChange={(e) => setInstance(e.target.value)}
                  style={{ width: "200px" }}
                />
              </Form.Field>
              <Form.Field inline>
                <label style={{ minWidth: "6rem" }}>User name:</label>
                <input
                  disabled={saveButtonDisabled}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  style={{ width: "200px" }}
                />
              </Form.Field>
              <Form.Field inline>
                <label style={{ minWidth: "6rem" }}>Password:</label>
                <input
                  disabled={saveButtonDisabled}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ width: "200px" }}
                />
              </Form.Field >
              <div style={{ marginTop: "1rem" }}>
                <Button className="integration-save-button" color="blue" size="small" 
                  onClick={() => {
                    const payload = { datasetId, credential: { username, password, instance } };
                    setShowLoader(true);
                    dispatch(saveServiceNowIntegration(payload))
                      .then(() => {
                        showToaster("Integration Saved successfully", "success");
                        setSaveButtonDisabled(true);
                      })
                      .catch((error) => {
                        console.error("Error saving integration:", error);
                        showToaster("Failed to save. Please try again.", "error");
                      })
                      .finally(() => {
                        setShowLoader(false);
                      });
                  }}
                  disabled={saveButtonDisabled}
                >
                  Save
                </Button>
                <Button className="integration-delete-button" color="blue" size="small"
                  onClick={() => {
                    setShowLoader(true);
                    dispatch(deleteServiceNowIntegration(datasetId))
                      .then(() => {
                        setInstance("");
                        setUsername("");
                        setPassword("");
                        showToaster("Integration Deleted successfully", "success");
                        setSaveButtonDisabled(false);
                      })
                      .catch((error) => {
                        console.error("Error deleting integration:", error);
                        showToaster("Failed to delete. Please try again.", "error");
                      })
                      .finally(() => {
                        setShowLoader(false);
                      });
                  }}
                >
                  Delete
                </Button>
              </div>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )}

    {/* Conditionally render the Email Support Settings form */}
      {thirdPartySubTab === "emailSupport" && (
        <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
          <Form>
            <Form.Field inline>
            <label style={{ minWidth: "6rem" }}>For email support, use this Email Id:</label>
            <input
              disabled={saveButtonDisabled}
              type="email"
              value={supportEmail}
              onChange={(e) => 
                  setSupportEmail(e.target.value)
              }
              style={{ width: "200px" }}
            />
            </Form.Field>
            <Form.Field inline>
            <label style={{ minWidth: "6rem" }}>Prompt:</label>
            <textarea
              disabled={saveButtonDisabled}
              placeholder="Enter a custom prompt for email support"
              value={supportPrompt}
              onChange={(e) => setSupportPrompt(e.target.value)}
              style={{ width: "360px" , height: "100px", borderRadius: "12px" }}
            />
            </Form.Field>
          
            <div style={{ marginTop: "1rem" }}>
            <Button
      className="integration-save-button"
      color="blue"
      size="small"
      onClick={() => {
    setShowLoader(true);
    dispatch(sendEmailSupport({
      toEmail: supportEmail,
      orgKey: orgKey,
      datasetId: datasetId,
      prompt: supportPrompt,
    }))
      .then(() => {
        showToaster("Email Support Saved successfully", "success");
        setSaveButtonDisabled(true);
      })
      .catch((error) => {
        console.error("Error saving email support:", error);
        showToaster("Failed to save email support.", "error");
      })
      .finally(() => {
        setShowLoader(false);
      });
  }}
  disabled={saveButtonDisabled}
>
  Confirm
</Button>


<Button
  className="integration-delete-button"
  color="blue"
  size="small"
  onClick={() => {
    setShowLoader(true);
    dispatch(deleteEmailSupport(supportEmail))
      .then(() => {
        setSupportEmail("");
        setSaveButtonDisabled(false);
        showToaster("Email Support Deleted successfully", "success");
      })
      .catch((error) => {
        console.error("Error deleting email support:", error);
        showToaster("Failed to delete email support", "error");
      })
      .finally(() => {
        setShowLoader(false);
      });
  }}
>
  Delete
</Button>


              </div>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )}
    {thirdPartySubTab === "agentEmail" && (
      <Grid>
        <Grid.Row>
        <Grid.Column width={8}>
          <Form>
            <Form.Field inline>
              <label style={{ minWidth: "6rem" }}>Human Agent Email:</label>
              <input
                disabled={agentEmailSaveButtonDisabled}
                value={agentEmail}
                onChange={(e) => setAgentEmail(e.target.value)}
                style={{ width: "200px" }}
              />
            </Form.Field>
            <Button
              className="integration-save-button"
              color="blue"
              size="small"
              onClick={handleAgentEmailSave}
              disabled={agentEmailSaveButtonDisabled}
            >
              Save
            </Button>
            <Button
              className="integration-delete-button"
              color="blue"
              size="small"
              onClick={handleAgentEmailDelete}
            >
              Delete
            </Button>
          </Form>
        </Grid.Column>
      </Grid.Row>
    </Grid>
    )}
  </div>
            ) : OpenAssistantSettingsBox ? (
              <div className="assistant-settings-form">
              <AssistantSettings
               datasetId={datasetId}
               isReadOnly={isReadOnly}
               onServiceAgentToggle={handleServiceAgentToggle} // Pass the callback function
               />
            </div>
          ) : null}


        </div>

        <Modal
          open={open}
          onClose={handleClose}
          //size="tiny"
          className="add-document-model"
          style={{ width: "35%", padding: "0px !important" }}
        >
          <Modal.Content>
            <h3 style={{ display: "flex" }}>
              <b>Add Document  </b>
              <Popup
                inverted
                position="right center"
                trigger={
                  <Image
                    className="pdfHoverImg"
                    src="/images/Info.svg"
                    alt="Info"
                    style={{ width: "20px", height: "20px" }}
                  />
                }
                style={{ borderRadius: "15px" }}
              >
                <div>
                  <div>You can only upload</div>
                  <div>20 documents</div>
                </div>
              </Popup>

            </h3>


            {showDocumentError && (
              <div className="document-error-msg">
                <div>
                  <Image src="/images/Alert red.svg" alt="Info" />
                </div>
                <div className="doc-error-message">
                  {maxFilesSize && <p>{maxFilesSize}</p>}
                  {maxFilesCount && <p>{maxFilesCount}</p>}
                </div>
                <div onClick={closeDocumentErrorBox}>
                  <Image src="/images/Close red.svg" alt="Close" />
                </div>
              </div>
            )}

            {fileExistFlag && (
              <div className="document-error-msg">
                <div>
                  <Image src="/images/Alert red.svg" alt="Info" />
                </div>
                <div className="doc-error-message">
                  <p>You cannot upload the same file to both the Domain Data and Content sections.</p>
                </div>
                <div onClick={closeDocumentFlagErrorBox}>
                  <Image src="/images/Close red.svg" alt="Close" />
                </div>
              </div>
            )}
            {isAssistant ? (
              <>
                <CustomFileUpload
                  title="Add Content files"
                  popupMessage="Basic documents that have content on which querying should happen."
                  uploadedFiles={uploadedFiles.filter((file) => file.fileflag === "pdfonly")}
                  onRemoveFile={handleRemoveFile}
                  onDrop={(acceptedFiles) => onDrop(acceptedFiles, "pdfonly")}
                  allowedFileTypesMessage="Only PDF files allowed"
                  maxFileSizeMessage={`Max file size: ${process.env.REACT_APP_DOCUMENT_UPLOAD_FILE_SIZE}`}
                  dropzoneStyles={dropzoneStyles}
                  getRootProps={getRootPropsPDFOnly}
                  getInputProps={getInputPropsPDFOnly}
                  isDragActive={isDragActivePDFOnly}
                />
              </>
            ) : (
              <>
                <CustomFileUpload
                  title="Add Domain Data files"
                  popupMessage="Dataset specific files that contain glossary / standard terms related to each other."
                  uploadedFiles={uploadedFiles.filter((file) => file.fileflag === "onlypdf")}
                  onRemoveFile={handleRemoveFile}
                  onDrop={(acceptedFiles) => onDrop(acceptedFiles, "onlypdf")}
                  allowedFileTypesMessage="PDF, MD files allowed"
                  maxFileSizeMessage={`Max file size: ${process.env.REACT_APP_DOCUMENT_UPLOAD_FILE_SIZE}`}
                  dropzoneStyles={dropzoneStyles}
                  getRootProps={getRootPropsPDF}
                  getInputProps={getInputPropsPDF}
                  isDragActive={isDragActivePDF}
                />
                <CustomFileUpload
                  title="Add Content files"
                  popupMessage="Basic documents that have content on which querying should happen."
                  uploadedFiles={uploadedFiles.filter((file) => file.fileflag === "pdfandcsv")}
                  onRemoveFile={handleRemoveFile}
                  onDrop={(acceptedFiles) => onDrop(acceptedFiles, "pdfandcsv")}
                  allowedFileTypesMessage="PDF, CSV, MD files allowed"
                  maxFileSizeMessage={`Max file size: ${process.env.REACT_APP_DOCUMENT_UPLOAD_FILE_SIZE}`}
                  dropzoneStyles={dropzoneStyles}
                  getRootProps={getRootPropsPDFCSV}
                  getInputProps={getInputPropsPDFCSV}
                  isDragActive={isDragActivePDFCSV}
                />
              </>
            )}
          </Modal.Content>
          <Modal.Actions>
            <button
              className="cancel-btn"
              onClick={handleClose}
              data-cy="cancel-document-upload-cy"
              style={{ width: '22%' }}
            >
              Cancel
            </button>
            <button
              disabled={!isButtonEnabled}
              className="add-btn"
              onClick={handleUpload}
              data-cy="add-document-upload-cy"
              style={{ width: '22%' }}
            >
              Add
            </button>
          </Modal.Actions>
        </Modal>

        <Modal
          open={openUserBox}
          onClose={handleCloseUserModel}
          size="tiny"
          className="add-document-model addUserPopup"
        >
          <Modal.Content>
            <Header as="h3">Assign User</Header>
            <div className="menu-item-search searchBox">
              <input
                type="text"
                id="addUserPopup"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder=""
                data-cy="search-user-input-cy"
              />
              <label htmlFor="addUserPopup">
                <img src="/images/search.svg" alt="Logo" />
                Search
              </label>
            </div>
            {userData.length > 0 ? (
              <AddUserDocPaginationTable
                columns={userColumns}
                data={userData}
                setselectedUsersData={setselectedUsersData}
                selectedUsers={selectedUsersData}
                onDataFromChild={handleDataFromChild}
              />
            ) : (
              <div className="emptyContainer">
                <Image src="/images/empty-state.svg" alt="Empty State" />
                <p className="emptyMessage">
                  <span className="titleMessage">No data available </span>
                </p>
              </div>
            )}
          </Modal.Content>
          <Modal.Actions>
            <button
              className="cancel-btn"
              onClick={handleCloseUserModel}
              data-cy="add-users-cancel"
            >
              Cancel
            </button>
            <button
              disabled={!dataFromChildCheckbox.length > 0}
              className="add-btn"
              onClick={handleAddUser}
              data-cy="add-users-submit"
            >
              Add
            </button>
          </Modal.Actions>
        </Modal>


        <Modal open={openUrlBox} size="tiny" sx={{ padding: '0px !important' }}>
          <div style={{ width: '100%', textAlign: 'center', padding: '10px 0', display: 'flex', alignItems: 'center' }}>
            <h3 style={{ display: "flex" }}>Add Website Link</h3>
            <Popup
              inverted
              position="right center"
              trigger={
                <Image
                  className="pdfHoverImg"
                  src="/images/Info.svg"
                  alt="Info"
                  style={{ width: "20px", height: "20px", marginBottom: '14px' }}
                />
              }
              style={{ borderRadius: "15px" }}
            >
              <div>
                <div>Enter a URL to extract the page  </div>
                <div>content and save it as a PDF.</div>
                <div>and select training frequency</div>
              </div>
            </Popup>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: dataFromChildCheckbox.length > 0 ? '1px solid #ccc' : '' }}>

            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0px 0', borderRadius: '8px 8px 0 0' }}>
              <div style={{ margin: '10px 0', width: '100%' }}>
                <input
                  type="text"
                  id="websiteLink"
                  size='small'
                  value={inputLinkValue}
                  onChange={(e) => {
                    handleCheckLink();
                    setInputLinkValue(e.target.value)
                  }}
                  placeholder="Enter website link"
                  data-cy="website-link-input-cy"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <button
                onClick={handleAddLink}
                className="add-btn"
                data-cy="website-link-add-cy"
                disabled={!inputLinkValue || !isValidUrl(inputLinkValue)}  // Disable if input is empty
                style={{ margin: '10px 5px', padding: '15px 25px', borderRadius: '16px', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', background: !inputLinkValue || !isValidUrl(inputLinkValue) ? "#99baf8" : "" }}
              >
                {/* <Image
                  // src="/images/white-base-icons.svg"
                  alt="Add new Url"
                  style={{ paddingRight: "15px" }} /> */}
                Add
              </button>
            </div>
          </div>
          {urlErrorMessage !== '' && (
            <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', padding: '2px 0', borderBottom: dataFromChildCheckbox.length > 0 ? '1px solid #ccc' : '' }}>
              <p style={{ color: '#f44336', margin: '0px' }}>{urlErrorMessage}</p>
            </div>
          )}
          {addedLinks.length > 0 && (
            <Modal.Content>
              <div>
                <div style={{ marginBottom: '15px', padding: '10px', borderRadius: '8px' }}>
                  <ul>
                    {addedLinks.map((link, index) => (
                      <li key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Popup
                          content={link}
                          inverted
                          position="right center"
                          style={{ borderRadius: "15px" }}
                          trigger={<span>{link.slice(0, 40)}..</span>}
                        />
                        <button
                          onClick={() => handleRemoveLink(link)}
                          style={{
                            marginLeft: '10px',
                            color: '#f44336',
                            cursor: 'pointer',
                            background: 'none',
                            border: 'none',
                          }}
                          data-cy={`remove-link-${index}`}
                          onMouseEnter={() => setIsHovered(index)}  // Set hovered index
                          onMouseLeave={() => setIsHovered(null)}  // Reset hovered index
                        >
                          {isHovered !== index ? (
                            <Image
                              src="/images/grey-circle-close.svg"
                              alt="Upload"
                            />
                          ) : (
                            <Image
                              src="/images/red-circle-delete.svg"
                              alt="Upload"
                              style={{ cursor: 'pointer' }}
                            />
                          )}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                <div style={{ marginBottom: '5px' }}>
                  <Dropdown
                    placeholder="Select Frequency"
                    fluid
                    selection
                    options={[
                      { key: 'onetime', text: 'Onetime', value: '0' },
                      { key: '12 Hours', text: '12 Hours', value: '12' },
                      { key: '24 Hours', text: '24 Hours', value: '24' },
                    ]}
                    onChange={(e, { value }) => setSelectedFrequency(value)}
                    style={{ width: '100%' }}
                    data-cy="website-link-frequency-cy"
                  />
                </div>
              </div>
            </Modal.Content>
          )}
          <Modal.Actions style={{ padding: '0px !important', display: 'flex', justifyContent: 'center', alignItems: 'center', borderTop: "none" }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '5px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', gap: '2px' }}>
                <button
                  className="cancel-btn"
                  onClick={handleCloseUrl}
                  data-cy="add-link-cancel"
                  style={{ borderRadius: "16px", padding: '14px 27px' }}
                >
                  Cancel
                </button>
                <button
                  disabled={!addedLinks.length > 0}
                  className="add-btn"
                  onClick={handleAddDataLinks}
                  data-cy="add-links-submit"
                  style={{ background: addedLinks.length <= 0 ? '#99baf8' : '', borderRadius: "16px", padding: "14px 33px" }}
                >
                  Add
                </button>
              </div>
            </div>
          </Modal.Actions>
        </Modal>


        {DocUploadStatusFlag && (
          <DocUploadStatusModal
            documents={DocStatusArray}
            onClose={handleCloseDocStatusModal}
          />
        )}
      </div>
    </div>
  );

};

const dropzoneStyles = {
  border: "2px dashed #d3d3d3",
  borderRadius: "4px",
  padding: "10px",
  textAlign: "center",
  cursor: "pointer",
};

const formatBytes = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(k)));
  return Math.round(bytes / Math.pow(k, i)) + " " + sizes[i];
};

export default DataConsole;
